import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getProgramDistributionHistory = (programid) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_PROGRAM_DISTRIBUTION_HISTORY(programid)
  );
};

export default getProgramDistributionHistory;
